import React from 'react';
import { connect } from 'react-redux';

import PictureList from './common/PictureList';

import { fetchPictureData } from '../actions';
import { Container, Header } from 'semantic-ui-react';


class PictureBrowser extends React.Component {

    componentDidMount() {
        this.props.fetchPictureData(this.props.match.params.category);
    }

    render() {
        const { pictureData } = this.props;

        if (pictureData) {
            return (
                <Container fluid>
                    <PictureList pictureData={pictureData}/>
                </Container>
            );
        } else {
            return (
                <Container>
                    <Header as="h2">Loading ... </Header>
                </Container>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return { 
      pictureData: state.pictureData,
     };
};

export default connect (mapStateToProps, { fetchPictureData } )(PictureBrowser);